module.exports = __webpack_public_path__ + "img/中国荔枝博物馆1.1ce0d85c.png";